module.exports = "/_next/static/images/resume-badge-7ef88dc4e63311c2190a69b05198e618.jpg";